<template>
  <div>
    <div class="img">
      <img v-show="imgShow" :src="'data:image/jpeg;base64,' + src" />
      <!-- <div v-show="statusShow" class="img_box">
        <div class="but">
          <div class="text">请刷新二维码后重试</div>
          <el-button class="button" @click="refresh">刷新</el-button>
        </div>
      </div> -->
    </div>
    <!-- <div class="title" @click="refresh">
      刷新<i class="el-icon-refresh"></i>
    </div> -->
  </div>
</template>

<script>
import { apiCreateCode, apiRedirect } from "@/api/user/login";
export default {
  name: "PageWrap",
  props: {
    dataMsg: { type: Boolean, default: true },
  },
  data() {
    return {
      src: "",
      setInterval: "",
      statusShow: false,
      imgShow: false,
    };
  },
  components: {},
  watch: {
    dataMsg: {
      handler(n, o) {
        this.closeTime();
        if (n == true) {
          this.CreateCode();
        }
      },
    },
  },
  mounted() {},
  destroyed() {
    clearInterval(this.setInterval);
    this.setInterval = null;
  },
  methods: {
    refresh() {
      this.closeTime();
      this.CreateCode();
      this.statusShow = false;
    },
    closeTime() {
      clearInterval(this.setInterval);
      this.setInterval = null;
    },
    CreateCode() {
      let data = {
        customType: "pc",
      };
      apiCreateCode(data).then((res) => {
        this.src = res.imgCode;
        if (this.src) {
          this.imgShow = true;
        }
        this.setInterval = setInterval(() => {
          this.Redirect(res);
        }, 1000);
      });
    },
    Redirect(item) {
      let data = {
        qrcodeToken: item.qrcodeToken,
      };
      apiRedirect(data).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          //已扫描  用户同意
          if (res.data.status == "CONFIRMED") {
            this.closeTime();
            let token = res.data.userToken.access_token;
            this.$store.dispatch("appLogin", token).then(() => {
              this.$router.push("/index");
            });
          }
          //未扫描
          // if (res.data.status == "NOT_SCAN") {
          // }
          //已扫描 等待确认
          // if (res.data.status == "SCANNED") {
          // }
          //已扫描  用户取消
          if (res.data.status == "CANCELED") {
            this.closeTime();
            this.$message.warning("取消授权");
            this.CreateCode();
            this.statusShow = true;
          }
          //已过期
          if (res.data.status == "EXPIRED") {
            this.closeTime();
            this.$message.error("请刷新二维码后重试");
            this.CreateCode();
            this.statusShow = true;
          }
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.img {
  width: 300px;
  height: 300px;
  margin: 0 auto;
  img {
    width: 300px;
    height: 300px;
  }
  .img_box {
    width: 300px;
    height: 300px;
    background-color: rgba($color: #666, $alpha: 0.6);
    position: absolute;
    top: 255px;

    .but {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-content: center;
    }
    .button {
      width: 100px;
      margin: 100px auto;
    }
    .text {
      height: 30px;
      text-align: center;
    }
  }
}
.title {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
</style>
